/**
 * @generated SignedSource<<a43d8829d478ae6a74aaf0b5c95283db>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
type UserAvatar_user$fragmentType = any;
import type { FragmentType } from "relay-runtime";
declare export opaque type JobEventCancelation_event$fragmentType: FragmentType;
export type JobEventCancelation_event$data = {|
  +actor: {|
    +node: ?{|
      +name?: string,
      +$fragmentSpreads: UserAvatar_user$fragmentType,
    |},
  |},
  +timestamp: any,
  +$fragmentType: JobEventCancelation_event$fragmentType,
|};
export type JobEventCancelation_event$key = {
  +$data?: JobEventCancelation_event$data,
  +$fragmentSpreads: JobEventCancelation_event$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobEventCancelation_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timestamp",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JobEventActor",
      "kind": "LinkedField",
      "name": "actor",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "UserAvatar_user"
                }
              ],
              "type": "User",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "JobEvent",
  "abstractKey": "__isJobEvent"
};

(node/*: any*/).hash = "b56768b3fc42735453b1f8612f5b5ee3";

module.exports = ((node/*: any*/)/*: Fragment<
  JobEventCancelation_event$fragmentType,
  JobEventCancelation_event$data,
>*/);
